<template>
  <div class="row">
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
      >
        <b-tab title="Lista" active>
          <template v-slot:title> <i class="icofont-list"></i> Lista </template>
          <div>
            <div class="info-table py-4">
              <div class="info-table-item">
                <Subtitle
                  @exibirVermelhos="handleExibirVermelhos"
                  @exibirVerdes="handleExibirVerdes"
                  :setRed="setRed"
                ></Subtitle>
              </div>
              <div class="info-table-item">
                <download-files
                  :callback-pdf="generatePdf"
                  :data="displayedCadastros"
                  :fields="dataFields"
                  name="tria"
                >
                </download-files>
              </div>
            </div>
            <tabela-cadastros
              ref="table"
              :cadastros="displayedCadastros"
              :loading="loading"
              @filterSearch="filterSearch($event)"
            ></tabela-cadastros>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import { dataFields } from './utils.js'
import utils from '@/mixins/utils.js'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import Selects from '@/components/utils/Selects.vue'
import TabelaResultado from './TabelaResultado.vue'

export default {
  name: 'Tria',
  components: {
    Subtitle,
    apexchart: VueApexCharts,
    DownloadFiles,
    TitleTag,
    PulseLoader,
    TabelaCadastros,
    Selects,
    TabelaResultado,
  },
  mixins: [utils],
  data() {
    return {
      equipe: '',
      cadastros: [],
      cadastrosOriginais: [],
      loading: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...dataFields,
      },
      filterSearchTable: false,
      setRed: false,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      this.cadastros = this.cadastrosOriginais
      let response = Filter.filtro(
        this.cadastros,
        '',
        this.$store.state.micro_area,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
  },

  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        // mostra os vermelhos
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event == true) {
        // mostra os verdes
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.exibirCadastrosVerdes = false
      }
    },

    async onChangeMicroArea(event) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (event !== null) {
        this.situacao = ''
        this.micro_area = event?.micro_area
      } else {
        this.micro_area = ''
        this.cadastros = this.cadastrosOriginais
      }
    },

    async buscarDadosIniciais() {
      try {
        this.loading = true
        let response = await this.$api.get(
          `/app/tria/${this.$store.state.cod_ibge}/equipe/${this.$store.state.nu_ine}`
        )
        if (response) {
          this.cadastros = response.data
          this.cadastrosOriginais = response.data
        }
        this.loading = false
      } catch (error) {
        console.log(error)
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        '',
        this.$store.state.micro_area
      )
    },

    init() {
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
